module.exports = __webpack_public_path__ + "static/img/bin.b33f6a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/bin.png
// module id = DELN
// module chunks = 53